// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {Button, Form, Input} from "antd";
import {CheckOutlined, MinusOutlined} from "@ant-design/icons";
import * as AuthBackend from "./AuthBackend";
import * as ApplicationBackend from "../backend/ApplicationBackend";
import * as Util from "./Util";
import * as Setting from "../Setting";
import i18next from "i18next";
import {SendCodeInput} from "../common/SendCodeInput";
import * as UserBackend from "../backend/UserBackend";
import CustomGithubCorner from "../common/CustomGithubCorner";
import {withRouter} from "react-router-dom";
import * as PasswordChecker from "../common/PasswordChecker";
import {CaptchaModal} from "../common/modal/CaptchaModal";

class ForgetPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      applicationName: props.applicationName ?? props.match.params?.applicationName,
      msg: null,
      name: "",
      username: "",
      phone: "",
      email: "",
      dest: "",
      isVerifyTypeFixed: false,
      verifyType: "", // "email", "phone"
      current: 0,
      passwordAtLeast8: false,
      passwordLetterAndNumber: false,
      openCaptchaModal: false,
    };
    this.captcaModalRef = React.createRef();
    this.form = React.createRef();
  }
  componentDidMount() {
    if (this.getApplicationObj() === undefined) {
      if (this.state.applicationName !== undefined) {
        this.getApplication();
      } else {
        Setting.showMessage("error", i18next.t("forget:Unknown forget type") + ": " + this.state.type);
      }
    }
  }

  getApplication() {
    if (this.state.applicationName === undefined) {
      return;
    }

    ApplicationBackend.getApplication("admin", this.state.applicationName)
      .then((application) => {
        this.onUpdateApplication(application);
      });
  }
  getApplicationObj() {
    return this.props.application;
  }

  onUpdateApplication(application) {
    this.props.onUpdateApplication(application);
  }

  onFormFinish(name, info, forms) {
    switch (name) {
    case "step1":
      this.setState({
        openCaptchaModal: true,
        forms,
      });
      break;
    case "step2":
      UserBackend.verifyCode({
        application: forms.step2.getFieldValue("application"),
        organization: forms.step2.getFieldValue("organization"),
        username: forms.step2.getFieldValue("dest"),
        name: this.state.name,
        code: forms.step2.getFieldValue("code"),
        type: "login",
      }).then(res => {
        if (res.status === "ok") {
          this.setState({current: 2, code: forms.step2.getFieldValue("code")});
        } else {
          Setting.showMessage("error", res.msg);
        }
      });
      // this.setState({
      //   current: 2,
      //   code: forms.step2.getFieldValue("code"),
      // });

      break;
    default:
      break;
    }
  }

  onFinish(values) {
    values.username = this.state.username;
    values.userOwner = this.getApplicationObj()?.organizationObj.name;
    UserBackend.setPassword(values.userOwner, `@JK_${values.username}`, "", values?.newPassword, this.state.code).then(res => {
      if (res.status === "ok") {
        Setting.redirectToLoginPage(this.getApplicationObj(), this.props.history);
      } else {
        Setting.showMessage("error", res.msg);
      }
    });
  }

  onFinishFailed(values, errorFields) {}

  renderBackLink() {
    const application = this.getApplicationObj();
    return (
      <a
        onClick={() => {
          // Setting.goToLink("/login");
          const linkInStorage = sessionStorage.getItem("signinUrl");
          if (linkInStorage !== null && linkInStorage !== "") {
            Setting.goToLink(linkInStorage);
          } else {
            Setting.redirectToLoginPage(application, this.props.history);
          }
        }}
      >
        {`${i18next.t("forget:Go back to login")}`}
      </a>
    );
  }

  renderForm(application) {
    const username = this.form?.current?.getFieldValue("username");
    const {
      current,
      dest,
      verifyType,
      passwordAtLeast8,
      passwordLetterAndNumber,
      name,
    } = this.state;

    return (
      <Form.Provider onFormFinish={(name, {info, forms}) => {
        this.onFormFinish(name, info, forms);
      }}>
        {/* STEP 1: input username -> get email & phone */}
        {current === 0 ?
          <Form
            ref={this.form}
            name="step1"
            // eslint-disable-next-line no-console
            onFinishFailed={(errorInfo) => console.log(errorInfo)}
            initialValues={{
              application: application.name,
              organization: application.organization,
            }}
            size="large"
          >
            <div style={{minHeight: "160px"}}>
              <Form.Item
                name="username"
                rules={[
                  {
                    required: true,
                    message: i18next.t("login:Please input your Email!"),
                    whitespace: true,
                  },
                  {
                    validator: (_, value) => {
                      if (value && !Setting.isValidEmail(value)) {
                        return Promise.reject(i18next.t("signup:The input is not valid Email!"));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  bordered={false}
                  onChange={e => {
                    this.setState({
                      username: e.target.value,
                    });
                  }}
                  placeholder={i18next.t("login:Enter your registered email")}
                />
              </Form.Item>
              <div className="forgetBottom">
                {i18next.t("login:Please input your Email!")}
              </div>
            </div>
            <br />
            <Form.Item>
              <Button
                block
                htmlType="submit"
                style={{
                  background: "linear-gradient(to right, #71B9A4, #318545)",
                  color: "white",
                  border: "none",
                }}
              >
                {i18next.t("forget:Next Step")}
              </Button>
              <div style={{marginTop: "20px"}}>
                {this.renderBackLink()}
              </div>
            </Form.Item>
          </Form> : null}

        {/* STEP 2: verify email or phone */}
        {current === 1 ? <Form
          ref={this.form}
          name="step2"
          onFinishFailed={(errorInfo) =>
            this.onFinishFailed(
              errorInfo.values,
              errorInfo.errorFields,
              errorInfo.outOfDate
            )
          }
          onValuesChange={(changedValues, allValues) => {
            const verifyType = changedValues.dest?.indexOf("@") === -1 ? "phone" : "email";
            this.setState({
              dest: changedValues.dest,
              verifyType: verifyType,
            });
          }}
          initialValues={{
            application: application.name,
            organization: application.organization,
            dest,
          }}
          size="large"
        >
          <div style={{minHeight: "160px"}}>
            <Form.Item
              name="code"
              rules={[
                {
                  required: true,
                  message: i18next.t("code:Please input your verification code!"),
                },
              ]}
            >
              <SendCodeInput
                method={"forget"}
                onButtonClickArgs={[dest, verifyType, Setting.getApplicationName(this.getApplicationObj()), name]}
                application={application}
              />
            </Form.Item>
            <div className="forgetBottom">
              {i18next.t("forget:If your email")}&nbsp;{this.state.username || username}&nbsp;{i18next.t("forget:is available now ")}&nbsp;{i18next.t("forget:Please click to obtain the verification code")}
            </div>
          </div>
          <br />
          <Form.Item>
            <Button
              block
              htmlType="submit"
              style={{
                background: "linear-gradient(to right, #71B9A4, #318545)",
                color: "white",
                border: "none",
              }}
            >
              {i18next.t("forget:Next Step")}
            </Button>
            <div style={{marginTop: "20px"}}>
              {this.renderBackLink()}
            </div>
          </Form.Item>
        </Form> : null}

        {/* STEP 3 */}
        {current === 2 ?
          <Form
            ref={this.form}
            name="step3"
            onFinish={(values) => this.onFinish(values)}
            onFinishFailed={(errorInfo) =>
              this.onFinishFailed(
                errorInfo.values,
                errorInfo.errorFields,
                errorInfo.outOfDate
              )
            }
            initialValues={{
              application: application.name,
              organization: application.organization,
            }}
            size="large"
          >
            <Form.Item
              name="newPassword"
              className="firstPassword"
              hidden={current !== 2}
              rules={[
                // {required: true, message: i18next.t("login:Please input your password!")},
                () => ({
                  validator: (_, value) => {
                    if (value) {
                      const errorMsgAtLeast8 = PasswordChecker.checkPasswordComplexity(value, ["AtLeast8"]);
                      const errorMsgLetterAndNumber = PasswordChecker.checkPasswordComplexity(value, ["LetterAndNumber"]);
                      this.setState({
                        passwordAtLeast8: !errorMsgAtLeast8,
                        passwordLetterAndNumber: !errorMsgLetterAndNumber,
                      });
                      if (errorMsgAtLeast8 === "" && errorMsgLetterAndNumber === "") {
                        return Promise.resolve();
                      } else {
                        return Promise.reject("");
                      }
                    }
                    return Promise.reject(i18next.t("signup:Please input your password!"));
                  },
                }),
                // {
                //   validateTrigger: "onChange",
                //   validator: (_, value) => {
                //     const errorMsgAtLeast8 = PasswordChecker.checkPasswordComplexity(value, ["AtLeast8"]);
                //     const errorMsgLetterAndNumber = PasswordChecker.checkPasswordComplexity(value, ["LetterAndNumber"]);
                //     this.setState({
                //       passwordAtLeast8: !errorMsgAtLeast8,
                //       passwordLetterAndNumber: !errorMsgLetterAndNumber,
                //     });
                //     if (errorMsgAtLeast8 === "" && errorMsgLetterAndNumber === "") {
                //       return Promise.resolve();
                //     } else {
                //       return Promise.reject("");
                //     }
                //   },
                // },
              ]}
              hasFeedback
            >
              <Input.Password
                bordered={false}
                placeholder={i18next.t("general:Password")}
              />
            </Form.Item>
            <div className="passwordMsg-wrapper">
              <div className="passwordMsg">
                {passwordAtLeast8 ? <CheckOutlined style={{color: "#18933B"}} /> : <MinusOutlined />}
                {i18next.t("user:The password must have at least 8 characters")}
              </div>
              <div className="passwordMsg">
                {passwordLetterAndNumber ? <CheckOutlined style={{color: "#18933B"}} /> : <MinusOutlined />}
                {i18next.t("user:The password must contain a letter and a number")}
              </div>
            </div>
            <Form.Item
              name="confirm"
              dependencies={["newPassword"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: i18next.t("signup:Please confirm your password!"),
                },
                ({getFieldValue}) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      i18next.t("signup:Your confirmed password is inconsistent with the password!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                bordered={false}
                placeholder={i18next.t("signup:Confirm")}
              />
            </Form.Item>
            <br />
            <Form.Item hidden={current !== 2}>
              <Button
                block
                htmlType="submit"
                style={{
                  background: "linear-gradient(to right, #71B9A4, #318545)",
                  color: "white",
                  border: "none",
                }}
              >
                {i18next.t("forget:Confirm Reset")}
              </Button>
              <div style={{marginTop: "20px"}}>
                {this.renderBackLink()}
              </div>
            </Form.Item>
          </Form> : null}
      </Form.Provider>
    );
  }

  getCaptchaProviderItems(application) {
    const providers = application?.providers;

    if (providers === undefined || providers === null) {
      return null;
    }

    return providers.filter(providerItem => {
      if (providerItem.provider === undefined || providerItem.provider === null) {
        return false;
      }

      return providerItem.provider.category === "Captcha";
    });
  }

  handleOnOk(captchaType, captchaToken, clientSecret, ths) {
    const {forms} = ths.state;
    const username = forms.step1.getFieldValue("username");
    const organization = forms.step1.getFieldValue("organization");
    const data = {
      captchaType,
      captchaToken,
      clientSecret,
      username,
      organization,
    };
    AuthBackend.mailboxCheck(data)
      .then((res) => {
        if (res.status === "ok") {
          const phone = res.data.phone;
          const email = res.data.email;

          if (!phone && !email) {
            Setting.showMessage("error", "no verification method!");
            this.captcaModalRef?.loadCaptcha();
            this.captcaModalRef?.setCaptchaToken("");
          } else {
            this.setState({
              name: res.data.name,
              phone: phone,
              email: email,
              openCaptchaModal: false,
            });

            const saveFields = (type, dest, fixed) => {
              this.setState({
                verifyType: type,
                isVerifyTypeFixed: fixed,
                dest: dest,
              });
            };
            saveFields("email", email, true);
            this.setState({
              current: 1,
            });
          }
        } else {
          Setting.showMessage("error", res.msg);
          this.captcaModalRef?.loadCaptcha();
          this.captcaModalRef?.setCaptchaToken("");
        }
      });
  }

  renderCaptchaModal(application) {
    const captchaProviderItems = this.getCaptchaProviderItems(application);
    const alwaysProviderItems = captchaProviderItems.filter(providerItem => providerItem.rule === "Always");
    const dynamicProviderItems = captchaProviderItems.filter(providerItem => providerItem.rule === "Dynamic");
    const provider = (alwaysProviderItems.length > 0
      ? alwaysProviderItems[0]?.provider
      : dynamicProviderItems[0]?.provider) || captchaProviderItems[0]?.provider;
    if (!provider) {
      // this.setState({
      //   noCaptchModal: true,
      // });
      return null;
    }

    return <CaptchaModal
      onRef={(ref) => {this.captcaModalRef = ref;}}
      owner={provider.owner}
      name={provider.name}
      visible={this.state.openCaptchaModal}
      onOk={(arg1, arg2, arg3) => this.handleOnOk(arg1, arg2, arg3, this)}
      onCancel={() => this.setState({openCaptchaModal: false})}
      isCurrentProvider={true}
    />;
  }

  render() {
    const application = this.getApplicationObj();
    if (application === undefined) {
      return null;
    }
    if (application === null) {
      return Util.renderMessageLarge(this, this.state.msg);
    }

    return (
      <React.Fragment>
        <CustomGithubCorner />
        <div className="forget-content" style={{padding: Setting.isMobile() ? "30px" : "30px 110px"}}>
          <div style={{width: Setting.isMobile() ? "300px" : "360px"}}>
            <div style={{textAlign: "center", fontSize: "20px", fontWeight: "500"}}>
              {i18next.t("forget:Retrieve email password")}
            </div>
            {/* <Steps
              current={this.state.current}
              items={[
                {
                  title: i18next.t("forget:Account"),
                  icon: <UserOutlined />,
                },
                {
                  title: i18next.t("forget:Verify"),
                  icon: <SolutionOutlined />,
                },
                {
                  title: i18next.t("forget:Reset"),
                  icon: <KeyOutlined />,
                },
              ]}
              style={{
                marginTop: "80px",
              }}
            >
            </Steps> */}
            <div style={{marginTop: "40px", textAlign: "center"}}>
              {this.renderForm(application)}
            </div>
          </div>
        </div>
        {this.renderCaptchaModal(application)}
      </React.Fragment>
    );
  }
}

export default withRouter(ForgetPage);
